module.exports = __webpack_public_path__ + "media/src/images/top_covers/xmas_image_02-a7437d7464647502e8af2bcdbd9ae146.png";